import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import styles from './Music.module.css';
import OriginalMusic from './OriginalMusic';
import ProducedBy from './ProducedBy';
import MusicBuskAlbum from './MusicBuskAlbum';
import AlbumPage from './AlbumPage';
import { trackTabInteraction, trackNavigation } from '../utils/analytics';

const TABS = [
  { id: 1, label: 'Original Music', path: '.' },
  { id: 2, label: 'Produced By', path: 'producedby' },
];

const Music = () => {
  const location = useLocation();
  const [active, setActive] = useState(1);

  const hideMusicTabs =
    location.pathname.startsWith('/music/album/') || location.pathname === '/music/busk';

  useEffect(() => {
    if (location.pathname === '/music/producedby') setActive(2);
    else setActive(1);
  }, [location]);

  return (
    <div className={styles.container}>
      {!hideMusicTabs && (
        <div className={styles.tabs}>
          {TABS.map(tab => (
            <Link
              key={tab.id}
              to={tab.path}
              className={`${styles.tab} ${active === tab.id ? styles.activeTab : ''}`}
              onClick={() => {
                trackTabInteraction(tab.label, 'switch');
                trackNavigation(tab.label, `/music/${tab.path}`);
                setActive(tab.id);
              }}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      )}
      <div className={styles.musicBody}>
        <Routes>
          <Route path="album/:albumid" element={<AlbumPage />} />
          <Route path="/" element={<OriginalMusic />} />
          <Route path="producedby" element={<ProducedBy />} />
          <Route path="busk" element={<MusicBuskAlbum />} />
        </Routes>
      </div>
    </div>
  );
};

export default Music;
